import $axios from '../services/apiLms.js'
import moment from 'moment'

const state = () => ({
    // buku_tamus: [],
    buku_tamu_all: [],
    buku_tamu_today: [],
})

const mutations = {
    // ASSIGN_BUKUTAMU(state, payload) {
    //     state.tatibs = payload
    // },
    ASSIGN_BUKUTAMU_ALL(state, payload) {
        state.buku_tamu_all = payload
    },
    ASSIGN_BUKUTAMU_TODAY(state, payload) {
        state.buku_tamu_today = payload
    },
}

const actions = {
    // getTatibs({ commit }, paramsData) {
    //     return new Promise((resolve) => {
    //         $axios.get(`kepsek/tatib/detail?type=${paramsData.type}&time=${paramsData.time}`)
    //             .then((response) => {
    //                 commit('ASSIGN_BUKUTAMU', response.data.data)
    //                 resolve(response.data)
    //             })
    //     })
    // },
    getBukuTamuAll({ commit }, paramsData) {
        return new Promise((resolve) => {
            $axios.get(`kepsek/bukutamu`, { params : paramsData })
                .then((response) => {
                    commit('ASSIGN_BUKUTAMU_ALL', (response.data.data == undefined ? [] : response.data.data))
                    resolve(response.data)
                })
        })
    },
    getBukuTamuToday({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`kepsek/bukutamu`, { params : { type : 'daily', date : moment().format('YYYY-MM-DD') } })
                .then((response) => {
                    commit('ASSIGN_BUKUTAMU_TODAY', (response.data.data == undefined ? [] : response.data.data))
                    resolve(response.data)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}